var checkStringStartsWith = function checkStringStartsWith(token) {
  return function (key) {
    return typeof key === "string" && key.startsWith(token);
  };
};

var isCSSVariableName = /*@__PURE__*/checkStringStartsWith("--");
var startsAsVariableToken = /*@__PURE__*/checkStringStartsWith("var(--");

var isCSSVariableToken = function isCSSVariableToken(value) {
  var startsWithToken = startsAsVariableToken(value);
  if (!startsWithToken) return false; // Ensure any comments are stripped from the value as this can harm performance of the regex.

  return singleCssVariableRegex.test(value.split("/*")[0].trim());
};

var singleCssVariableRegex = /var\(\x2D\x2D(?:[\x2D0-9A-Z_a-z\u017F\u212A]+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*|[\x2D0-9A-Z_a-z\u017F\u212A]+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:(?![\t-\r \(\)\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])[\s\S])|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\((?:(?:(?![\(\)])[\s\S])|\((?:(?![\(\)])[\s\S])*\))*\))+[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)\)$/i;
export { isCSSVariableName, isCSSVariableToken };